import { render, staticRenderFns } from "./NotificationPanel.vue?vue&type=template&id=406ae2e5&"
import script from "./NotificationPanel.vue?vue&type=script&lang=js&"
export * from "./NotificationPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports